const module = 'PERMISSION_'

export const TOGGLE_PERMISSION = module + 'TOGGLE_PERMISSION'
export const TOGGLE_CATEGORY_PERMISSIONS = module + 'TOGGLE_CATEGORY_PERMISSIONS'
export const SET_CATEGORY_PERMISSIONS = module + 'SET_CATEGORY_PERMISSIONS'
export const SET_CATEGORIES = module + 'SET_CATEGORIES'
export const SET_ROLES = module + 'SET_ROLES'
export const SET_PERMISSIONS = module + 'SET_PERMISSIONS'
export const SET_ROOT_CATEGORY = module + 'SET_ROOT_CATEGORY'
export const SET_SELECTED_PERMISSIONS = module + 'SET_SELECTED_PERMISSIONS' // sets the permsissions selected in the Permission Tree
export const SET_USERS = module + 'SET_USERS'
export const SHOW_DELETE_USER_MODAL = module + 'SHOW_DELETE_USER_MODAL'
export const SET_NETWORKS = module + 'SET_NETWORKS'



// WEBPACK FOOTER //
// ./src/app/appLogic/permissions/store/constants.js